import * as Actions from '../actions';
import React, {Component} from 'react';

const initialState = {
    judul_panel_kanan: 'Judulnya kanan',
    isi_panel_kanan: (<div>isinya panel kanan dari redux</div>),
    window_dimension : {
        height: window.innerHeight,
        width: window.innerWidth
    },
    loading: false,
    tabBar:{
        beranda: false,
        kategori: false,
        cari: false,
        materi: false,
        profil: false
    },
    sekolah: {
        rows: [{
            nama: '---',
            npsn: '---',
            bentuk: '---',
            status: '---',
            kecamatan: '---',
            kabupaten: '---',
            provinsi: '---'
        }],
        total: 0
    },
    count_sekolah: {
        total: 0
    },
    rekap_sekolah: {
        rows: [{
            nama: '---',
            akreditasi: '---'
        }],
        total: 0
    },
    sekolah_individu: {
        rows: [{
            nama: '---',
            npsn: '---',
            bentuk: '---',
            status: '---',
            kecamatan: '---',
            kabupaten: '---',
            provinsi: '---'
        }],
        total: 0
    },
    wilayah: {
        rows: [{
            kode_wilayah: '---',
            nama: '---'
        }],
        total: 0
    },
    provinsi: {
        rows: [{
            kode_wilayah: '---',
            nama: '---'
        }],
        total: 0
    },
    kabupaten: {
        rows: [{
            kode_wilayah: '---',
            nama: '---'
        }],
        total: 0
    },
    kecamatan: {
        rows: [{
            kode_wilayah: '---',
            nama: '---'
        }],
        total: 0
    },
    dummy_rows:{
        rows: [{
            kode_wilayah: '---',
            nama: '---'
        },{
            kode_wilayah: '---',
            nama: '---'
        },{
            kode_wilayah: '---',
            nama: '---'
        },{
            kode_wilayah: '---',
            nama: '---'
        },{
            kode_wilayah: '---',
            nama: '---'
        }],
        total: 5
    },
    pengguna: {
        rows: [{
            pengguna_id: '---'
        }],
        total: 0
    },
    geojson_basic: [],
    semester: [],
    semester_aktif: { semester_id: '' },
    rekap_jumlah_satuan_pendidikan: { rows: [] },
    rekap_rombel: { rows: [] },
    rekap_ruang_kelas: { rows: [] },
    daftar_satuan_pendidikan: { rows: [] },
    daftar_rombel: { rows: [] },
    daftar_ruang: { rows: [] },
    data_apk_apm: { rows: [] },
    data_input_apk_apm: []
};

const appReducer = function (state = initialState, action) {
    switch ( action.type )
    {
        case Actions.UPDATE_WINDOW_DIMENSION:
        {
            return {
                ...state,
                window_dimension: action.window_dimension
            };
        }
        case Actions.SET_LOADING:
        {
            return {
                ...state,
                loading: action.loading
            };
        }
        case Actions.SET_TAB_ACTIVE:
        {
            // console.log(action.tabBar);

            return {
                ...state,
                tabBar: action.tabBar
            };
        }
        case Actions.GET_SEKOLAH:
        {
            return {
                ...state,
                sekolah: action.payload
            };
        }
        case Actions.GET_COUNT_SEKOLAH:
        {
            return {
                ...state,
                count_sekolah: action.payload
            };
        }
        case Actions.GET_REKAP_SEKOLAH:
        {
            return {
                ...state,
                rekap_sekolah: action.payload
            };
        }
        case Actions.GET_SEKOLAH_INDIVIDU:
        {
            return {
                ...state,
                sekolah_individu: action.payload
            };
        }
        case Actions.GET_WILAYAH:
        {
            return {
                ...state,
                wilayah: action.payload
            };
        }
        case Actions.GET_PROVINSI:
        {
            return {
                ...state,
                provinsi: action.payload
            };
        }
        case Actions.GET_KABUPATEN:
        {
            return {
                ...state,
                kabupaten: action.payload
            };
        }
        case Actions.GET_KECAMATAN:
        {
            return {
                ...state,
                kecamatan: action.payload
            };
        }
        case Actions.SET_JUDUL_KANAN:
        {
            return {
                ...state,
                judul_panel_kanan: action.judul_panel_kanan
            };
        }
        case Actions.SET_ISI_KANAN:
        {
            return {
                ...state,
                isi_panel_kanan: action.isi_panel_kanan
            };
        }
        case Actions.GET_PENGGUNA:
        {
            return {
                ...state,
                pengguna: action.payload
            };
        }
        case Actions.BUAT_PENGGUNA:
        {
            return {
                ...state,
                pengguna: action.payload
            };
        }
        case Actions.GET_GEOJSON_BASIC:
        {
            return {
                ...state,
                geojson_basic: action.payload
            };
        }
        case Actions.GET_SEMESTER:
        {
            return {
                ...state,
                semester: action.payload.semester,
                semester_aktif: action.payload.aktif
            }
        }
        case Actions.GET_REKAP_JUMLAH_SATUAN_PENDIDIKAN:
        {
            return {
                ...state,
                rekap_jumlah_satuan_pendidikan: action.payload
            }
        }
        case Actions.GET_REKAP_ROMBEL:
        {
            return {
                ...state,
                rekap_rombel: action.payload
            }
        }
        case Actions.GET_REKAP_RUANG_KELAS:
        {
            return {
                ...state,
                rekap_ruang_kelas: action.payload
            }
        }
        case Actions.GET_DAFTAR_SATUAN_PENDIDIKAN:
        {
            return {
                ...state,
                daftar_satuan_pendidikan: action.payload
            }
        }
        case Actions.GET_DAFTAR_ROMBEL:
        {
            return {
                ...state,
                daftar_rombel: action.payload
            }
        }
        case Actions.GET_DAFTAR_RUANG:
        {
            return {
                ...state,
                daftar_ruang: action.payload
            }
        }
        case Actions.GET_DATA_APK_APM:
        {
            return {
                ...state,
                data_apk_apm: action.payload
            }
        }
        case Actions.GET_DATA_INPUT_APK_APM:
        {
            return {
                ...state,
                data_input_apk_apm: action.payload
            }
        }
        case Actions.SET_DATA_APK_APM:
        {
            return {
                ...state,
                data_input_apk_apm: action.payload
            }
        }
        default:
        {
            return state;
        }
    }
}

export default appReducer;